import React from 'react';
import { Box, Typography, CircularProgress } from '@material-ui/core';
import * as R from 'ramda';
import moment from 'moment-timezone';

const ZoomConnectionsField = ({
  date,
  record,
  timezone,
  isAbsent,
  attendanceDataOverride,
  loadingOverride,
  errorOverride,
}) => {
  const loading = !!loadingOverride;
  const error = errorOverride;
  const data = attendanceDataOverride || [];

  if (loading) {
    return (
      <Box display="flex" alignItems="center">
        <CircularProgress size={20} />
      </Box>
    );
  }

  if (error && error.message !== 'No attendance data') {
    return (
      <Typography variant="body2" color="error" style={{ textAlign: 'center' }}>
        Error
      </Typography>
    );
  }

  if (isAbsent || !data || R.isEmpty(data)) {
    return (
      <Typography
        variant="body2"
        color="textSecondary"
        style={{ textAlign: 'center' }}
      >
        No zoom connections
      </Typography>
    );
  }

  const tz = timezone || 'Etc/UTC';
  const dateKey = date ? moment(date).format('YYYY-MM-DD') : null;
  const filtered = data.filter((r) => {
    const sameStudent = record?.id ? r.student_id === record.id : true;
    if (!dateKey) return sameStudent;
    const sessionDateKey = r.session_date
      ? moment(r.session_date).format('YYYY-MM-DD')
      : null;
    const joinDateKey = r.join_time
      ? moment(r.join_time).tz(tz).format('YYYY-MM-DD')
      : null;
    const sameDay = sessionDateKey === dateKey || joinDateKey === dateKey;
    return sameStudent && sameDay;
  });

  const sorted = [...filtered].sort((a, b) => {
    const aj = a?.join_time ? moment(a.join_time).valueOf() : 0;
    const bj = b?.join_time ? moment(b.join_time).valueOf() : 0;
    return aj - bj;
  });

  const parts = sorted
    .map((rec) => {
      const accessPart = rec?.join_time
        ? `Access: ${moment(rec.join_time).tz(tz).format('HH:mm')}`
        : null;
      const exitPart = rec?.leave_time
        ? `Exit: ${moment(rec.leave_time).tz(tz).format('HH:mm')}`
        : null;
      if (accessPart && exitPart) return `${accessPart} ${exitPart}`;
      if (accessPart) return accessPart;
      if (exitPart) return exitPart;
      return null;
    })
    .filter(Boolean);

  if (R.isEmpty(parts)) return null;
  return parts.join(' | ');
};

export default ZoomConnectionsField;
